'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// e.g. [1,2,3] -> /^((1|2|3)-?)*$/
var createHyphonRegexp = exports.createHyphonRegexp = function createHyphonRegexp() {
  var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var validList = valid instanceof Array ? valid : [valid];
  return new RegExp('^((' + validList.join('|') + ')-?)*$', 'i');
};
var rangeRegexp = exports.rangeRegexp = /^(\d+)?-?(\d+)?$/;


// WEBPACK FOOTER //
// ./src/api/helpers.js